<template>
    <div :href="comboUrl" class="vertical-product-card">
        <a :href="comboUrl" class="product-image">
            <img :src="baseImage" :class="{ 'image-placeholder': ! hasBaseImage }" alt="product-image">
        </a>

        <div class="product-info">
            <a :href="comboUrl" class="product-name">
                <h6>{{ combo.name }}</h6>
            </a>

            <div class="product-price" v-html="combo.formatted_price"></div>

            <!-- <ComboRating :ratingPercent="combo.rating_percent" :reviewCount="combo.reviews.length"/> -->
        </div>
    </div>
</template>

<script>
    //import ComboRating from './ComboRating.vue';
    import ComboCardMixin from '../mixins/ComboCardMixin';

    export default {
        components: {  }, //ComboRating

        mixins: [
            ComboCardMixin,
        ],

        props: ['combo'],
    };
</script>
